<template>
  <el-select
    :value="value"
    size="small"
    filterable
    allow-create
    default-first-option
    placeholder="输入后回车可新建"
    @change="handleChange"
    @blur="handleBlur"
    style="width: 100%"
    ref="itemSelect"
  >
    <el-option
      v-for="(item, index) in lists"
      :key="index"
      :label="item"
      :value="item"
    ></el-option>
  </el-select>
</template>

<script>
import { purchaseOrderItemList } from '@/service/getData'

export default {
  props: {
    value: '',
    paramName: String,
    category: {
      type: Number,
      default: 0,
    },
    table: String,
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    handleBlur() {
      setTimeout(() => {
        this.$emit('blur', this.value)
      }, 100)
    },
    async requestData() {
      let data = {
        params_options: true,
        table_name: this.table,
        category: this.category,
        param_name: this.paramName,
      }
      let res = await purchaseOrderItemList(data)
      this.lists = res.data
    },
  },
}
</script>